import React, { useState, useEffect } from "react";
import "./loanTips.css";

const tips = [
  { id: 1, icon: "💳", title: "Keep Your Credit Score Healthy", desc: "A good credit score reflects financial discipline and helps you secure faster approvals, higher loan amounts, and more favourable interest rates. Regularly check your score and address any discrepancies promptly to maintain a strong financial profile." },
  { id: 2, icon: "🏦", title: "Compare Loan Offers", desc: "Explore offers from multiple lenders to secure the best rate, repayment terms, and flexibility. Comparing options ensures you do not overpay and helps you choose a loan that aligns with your financial goals." },
  { id: 3, icon: "💡", title: "Borrow Only What You Need", desc: "Keep your loan minimal to manage repayments easily and stay financially balanced. Only borrow what is necessary for your immediate requirements to avoid unnecessary debt and interest burden." },
  { id: 4, icon: "⏰", title: "Repay On Time", desc: "Paying your EMIs on schedule strengthens your credit history and helps you avoid penalties. Late payments can affect your credit score and increase the total cost of the loan." },
  { id: 5, icon: "📑", title: "Understand Loan Terms Clearly", desc: "Review every detail thoroughly—fees, prepayment options, penalties, and hidden charges—to make informed decisions. Never hesitate to ask your lender for clarification on unclear terms." },
  { id: 6, icon: "🛡️", title: "Maintain a Backup Fund", desc: "Emergency savings protect your repayment schedule during unexpected events and financial challenges. Keep at least 3–6 months of EMIs aside to ensure uninterrupted repayment and peace of mind." },
];


const LoanTipsEnhanced = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % tips.length);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="enhanced-slider-section">

        <h2 className="loan-tips-title mb-4">
             Expert <span className="highlight"> Loan</span>Tips
            </h2>

      <div className="enhanced-slider-wrapper">
        {tips.map((tip, idx) => (
          <div
            key={tip.id}
            className={`enhanced-slide ${idx === current ? "active" : "inactive"}`}
          >
            <div className="icon-circle">{tip.icon}</div>
            <div className="slide-text">
              <h3>{tip.title}</h3>
              <p>{tip.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="enhanced-dots">
        {tips.map((_, idx) => (
          <span
            key={idx}
            className={idx === current ? "dot active" : "dot"}
            onClick={() => setCurrent(idx)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default LoanTipsEnhanced;
